import React from 'react';
import classNames from 'classnames';
import Button from '../Button/Button';

const Card = ({
  className = '',
  bgClass = '',
  shadow = false,
  responsive = false,
  href,
  imageUrl = '',
  imageBorder = false,
  overlayTitle = false,
  title = '',
  titleUppercase = false,
  titleSize = '',
  titleCentered = false,
  tag = '',
  typeIconUrl = '',
  typeLabel = '',
  pubDate = '',
  eventDate = '',
  eventLocation = '',
  description = '',
  ctas = [],
  ...props
}) => {
  const Tag = href ? 'a' : 'div';

  return (
    <Tag
      href={href}
      className={classNames('card', className, bgClass, {
        'card--shadow': shadow,
        'card--responsive': responsive,
        'card--overlay': overlayTitle,
      })}
      {...props}
    >
      <div className="card__wrapper">
        {imageUrl && (
          <div
            className={classNames('card__image', {
              'card__image--border': imageBorder,
            })}
            style={{ backgroundImage: `url(${imageUrl})` }}
          ></div>
        )}
        <div className="card__content">
          {(tag || pubDate || typeIconUrl) && (
            <div className="card__pre-meta">
              {tag && (
                <div className="card__pre-meta-left">
                  {tag && <span className="tag">{tag}</span>}
                </div>
              )}
              {(pubDate || typeIconUrl) && (
                <div className="card__pre-meta-right">
                  <div className="card__pub-date">{pubDate}</div>
                  <div className="card__type">
                    <span className="sr-only">{typeLabel}</span>
                    <img alt={typeLabel} src={typeIconUrl} />
                  </div>
                </div>
              )}
            </div>
          )}
          <div
            className={classNames('card__title', {
              'card__title--large': titleSize === 'large',
              'card__title--xlarge': titleSize === 'xlarge',
              'card__title--uppercase': titleUppercase,
              'card__title--center': titleCentered,
            })}
          >
            {title}
          </div>
          {description && (
            <div className="card__description">{description}</div>
          )}
          {(eventDate || eventLocation) && (
            <div className="card__post-meta">
              <div className="card__event-date">{eventDate}</div>
              <div className="card__event-location">{eventLocation}</div>
            </div>
          )}

          {ctas.length > 0 && (
            <div className="card__ctas">
              {ctas.map((cta, index) => (
                <Button key={`card-cta-${index}`} {...cta} />
              ))}
            </div>
          )}
        </div>
      </div>
    </Tag>
  );
};

export default Card;
